export default {
  "pl": {
    "decision_type": {
      "actions": {
        "add_competitor": "Dodaj konkurenta(-ów)",
        "add_decision_partners": "Dodaj grupę partnerów decyzji",
        "create_category": "Dodaj nową kategorię",
        "delete": "Usuń",
        "deleteMultiple": "Usuń…",
        "delete_cancel": "Anuluj",
        "edit": "Edytuj",
        "newDecisions": "Nowa decyzja",
        "save": "Zapisz",
        "show": "Pokazać",
        "submit": "Prześlij"
      },
      "attributes": {
        "created_at": "Stworzony w",
        "description": "Opis",
        "name": "Rodzaj (np. kuchnia, łazienka, podłoga…)",
        "responsible": "Osoba odpowiedzialna",
        "start_date": "Data rozpoczęcia"
      },
      "labels": {
        "allowCreditExplainer": "Zezwolenie na kredyt uwzględnia zatwierdzone decyzje poniżej budżetu. Kwoty kredytu zostaną pokazane na liście jednostek i wewnątrz propozycji. Będzie to również widoczne dla klienta.",
        "auto_close": "Zamknij decyzję automatycznie po upływie terminu",
        "auto_close_info": "Zamknięcie decyzji uniemożliwia klientowi zatwierdzenie propozycji, gdy żadna decyzja nie została podjęta. Jest to przydatne, gdy masz napięte terminy.",
        "bulk_upload": "Prześlij",
        "category_name": "Nazwa kategorii",
        "closes_on_deadline": "Zamyka po terminie",
        "createNewPartner": "Możesz też utworzyć konto nowego partnera",
        "decision_belongs_to": "Ta decyzja należy do",
        "decision_type_category_description": "Przypisanie wielu decyzjom kategorii, takiej jak kuchnia, łazienka itp., pogrupuje je razem i pozwoli na lepszy nadzór",
        "deleteGroupSubtitle": "To spowoduje usunięcie wszystkich rozmów, ofert i dokumentów utworzonych przez członków grupy {group_name} w odniesieniu do: {decision_type_name}.",
        "deleteGroupTitle": "Zamierzasz usunąć grupę: {group_name}",
        "disclaimerDeleteGroup": "Usunięcie grupy {group_name} spowoduje cofnięcie publikacji wszystkich decyzji dla partnerów decyzji. Gdy ta decyzja znów będzie miała partnerów decyzji, zyskasz możliwość opublikowania jej dla nich ponownie.",
        "editGroup": "Edytuj: {group_name}",
        "editPartnerRights": "Edytuj dotyczące komunikacji uprawnienia partnera decyzji",
        "editPartnerRightsLater": "Możesz też zrobić to później",
        "explainerPartners": "Dodaj partnerów decyzji zewnętrznych, aby móc razem pracować nad: {decision_type_name}",
        "export_preparing": "Zebranie wszystkich ofert może zająć do kilku minut. Gdy będą gotowe do pobrania, otrzymasz powiadomienie.",
        "export_proposals_approved": "Eksportuj zatwierdzone oferty",
        "groupRightsWarning": "Uwaga! Wszystkie rozmowy między klientem a partnerami zostaną usunięte. To działanie jest nieodwracalne. Czy na pewno chcesz kontynuować?",
        "last_updated_at": "Ostatnia aktualizacja o",
        "matrix": "Statystyki",
        "new_category": "Nowa kategoria decyzji",
        "noPartnersAddedYet": "Nie dodano jeszcze partnerów decyzji",
        "noResultPartner": "Brak wyników dotyczących partnera: {partner_name}",
        "partners": "Partnerzy decyzji",
        "projectUnitsTotal": "{project_name} ma łącznie {units_count_max} jednostek",
        "proposal_uploaded": "propozycja przesłana",
        "published_state": "Stan publikacji",
        "searchPartners": "Szukaj partnerów decyzji",
        "setUpPartners": "Wyznacz partnerów decyzji",
        "start_date_description": "Data wyłącznie do użytku wewnętrznego. Można to wykorzystać do określenia kolejności, w jakiej Twój zespół pracuje nad decyzjami",
        "start_date_title": "Data rozpoczęcia (opcjonalnie)",
        "step1Title": "Jakiego rodzaju decyzję mają podjąć twoi klienci?",
        "tab_proposal_templates": "Szablony propozycji",
        "tab_units": "Jednostki",
        "upsellCategoryTypes": "Deze functie is niet inbegrepen in uw pakket. Neem contact met ons op via de blauwe knop voor meer informatie.",
        "view": "Widok",
        "view_list": "Lista",
        "view_table": "Tabela",
        "writeEmployeeNameReject": "Aby kontynuować, wpisz: <i><b>{employeeName}</b></i>."
      },
      "toasts": {
        "bulk_delete": "Decyzja została usunięta | Decyzje zostały usunięte",
        "update": "Decyzja została zaktualizowana"
      },
      "validation": {
        "nameAlreadyTaken": "Nazwa jest już zajęta w tym projekcie",
        "needName": "Należy podać tytuł",
        "projectRequired": "Wybierz projekt",
        "selectDecisionType": "Wybierz przynajmniej 1 decyzję",
        "selectSharingOption": "Wybierz, komu chcesz udostępnić dokument(y)"
      }
    }
  }
}
